import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Partner } from '@chancenwerk/shared/master-data-management/partner/entities/Partner.js';
import { MarktVeranstaltungsAkquiseEntry } from './MarktVeranstaltungsAkquiseEntry.js';

/**
 * @entity MarktAkquise
 */
@Entity()
export class MarktVeranstaltungsAkquise extends MongoEntity {
  public static override _class = 'MarktVeranstaltungsAkquise';
  public static override _collectionName = 'markt-akquise';

  @Field(() => String)
  partnerID: Maybe<string>;

  @DataLoadedField(() => Partner, ({ partnerID }) => partnerID)
  partner: Maybe<Partner>;

  @Field(() => [MarktVeranstaltungsAkquiseEntry])
  entries: Maybe<MarktVeranstaltungsAkquiseEntry[]>;

  hasTodo() {
    if (this.entries?.length === 0) {
      return false;
    }

    const countDoneDenied = this.entries?.reduce((acc, entry) => {
      console.log(entry?.getLatestStatus());
      if (
        entry?.getLatestStatus() === 'DONE' ||
        entry?.getLatestStatus() === 'DENIED' ||
        entry?.getLatestStatus() === 'ENDED' ||
        entry?.getLatestStatus() === 'Leer'
      ) {
        return acc + 1;
      }
      return acc;
    }, 0);

    if (countDoneDenied === this.entries?.length) {
      return false;
    }

    return true;
  }
}
